module.exports = __webpack_public_path__ + "static/img/sg_btn2.3ada384.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/role3/control/sg_btn2.png
// module id = ey2H
// module chunks = 7